export default "__VITE_ASSET__D0mk3DxW__";